import packageJson from '../../package.json';

/** Version affichée (footer, modale release notes) — alignée sur package.json */
export const APP_VERSION = packageJson.version;

function depVersion(name) {
  const raw = packageJson.dependencies?.[name] || '';
  return String(raw).replace(/^[\^~>=<\s]+/, '') || '?';
}

/** Versions libs affichées dans le footer */
export const REACT_VERSION = depVersion('react');
export const MANTINE_VERSION = depVersion('@mantine/core');
